import { DateTime } from 'luxon';

export const formatDate = (date: DateTime, format: string = 'cccc, LLLL dd') => date.toFormat(format);
